export default __webpack_public_path__ + "static/media/LONG.c0475d19.png";